export default {
  baseUrl: '/power-cable-portal',
  baseUrl2: '/power-cable/',
  POWER_CABLE_PAY: '/power-cable-pay',
  POWER_CABLE_BASE: '/power-cable-base',
  POWER_CABLE_LOGISTICS: '/power-cable-logistics',
  POWER_CABLE_REPORT: '/power-cable-report',
}
